import { useState } from "react";
import { useTranslation } from "react-i18next";
import libro_azul from '../../../assets/img/libro_Azul.png'
import libroBlanco from "../../../assets/img/portada_libro_blanco_ricardo_salinas.png";
import "./coleccion.css";

const Coleccion = () => {
  const [activeTab, setActiveTab] = useState(1);

  const [t, i18n] = useTranslation("librVerd");

  const liga_lang1 = "/" + i18n.language + "/LibroNegocios";
  const liga_lang2 = "/" + i18n.language + "/LibroLibertad";

  return (
    <div className="NLV_coleccion">
      <div className="NLV_coleccion_titulo">
        <h2>
          {t("coleccion.titulo")}
          <span>IDEAS</span>
        </h2>
        {/* 
        {activeTab === 1 ? (
          <img src={libro_azul} alt="imagen libro" />
        ) : (
          <img src={libroBlanco} alt="imagenLibro" />
        )}*/}
      </div>
      {/*<div className="NLV_coleccion_otros">
        <div className="NLV_coleccion_otros_azul">
          <p
            className={`NLV_coleccion_otros_azul_p ${
              activeTab === 1 ? "active" : ""
            }`}
            onClick={() => setActiveTab(1)}
          >
            {t("coleccion.libro_azul")}
          </p>

          <a href={liga_lang1} className="btn_colec">
            {t("coleccion.button")}
          </a>
        </div>
        <div className="NLV_coleccion_otros_blanco">
          <p
            className={`NLV_coleccion_otros_blanco_p ${
              activeTab === 2 ? "active" : ""
            }`}
            onClick={() => setActiveTab(2)}
          >
            {t("coleccion.libro_blanco")}
          </p>

          <a href={liga_lang2} className="btn_colec">
            {t("coleccion.button")}
          </a>
        </div>
          </div>*/}
    </div>
  );
};

export default Coleccion;
